// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"80c4d6c3b7c0ed2acd01","997":"4f06cce10dd34890ed7d"}[chunkId] + ".css";
};